import { Component } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { BRAND, DEMO } from "src/app/config/brand.config";
import { SharedModule } from "src/shared/shared.module";

@Component({
  selector: "app-banner",
  imports: [SharedModule, RouterModule, TranslateModule],
  templateUrl: "./banner.component.html",
  styleUrl: "./banner.component.scss",
})
export class BannerComponent {
  readonly brand = BRAND;
  readonly demo = DEMO;
}
